import store from '../store';
import AWS from 'aws-sdk';

export default {

    authenticate: function () {
        var domain = process.env.AWS_COGNITO_USER_POOL_DOMAIN;
        var clientId = process.env.AWS_COGNITO_CLIENT_ID;
        var type = 'token';
        var scope = 'openid profile';

        var callback = window.location.protocol + '//' + window.location.host + '/callback';

        // Save the 'verification' value, so it can be verified later to prevent CSRF attacks
        var verification = generateVerification();
        store.commit('setVerification', verification);

        // Use the hosted UI
        window.location.href = 'https://' + domain + '/login?response_type=' + type + '&client_id=' + clientId + '&redirect_uri=' + callback + '&state=' + verification + '&scope=' + scope;
    },

    getCredentialsForRole: async function (role) {
        return new Promise((resolve, reject) => {
            getCognitoIdentity()
                .then((identity) => {
                    if (identity.roles[role]) {
                        resolve(identity.roles[role]);
                    } else {
                        let params = {
                            IdentityId: identity.identityId,
                            CustomRoleArn: role,
                            Logins: {}
                        };

                        params.Logins[process.env.AWS_COGNITO_PROVIDER_ID] = store.state.auth.idToken;

                        let cognitoidentity = new AWS.CognitoIdentity();
                        cognitoidentity.getCredentialsForIdentity(params, (err, data) => {
                            if (err) {
                                if (err.statusCode === 400 &&
                  (err.message.indexOf('Invalid login token. Token expired') > -1 ||
                    err.message.indexOf('Unauthenticated access is not supported for this identity pool.') > -1)) {
                                    store.dispatch('handleSessionExpired', err);
                                }
                                reject(err);
                            } else {
                                store.commit('setCognitoIdentityRole', { name: role, value: data });
                                resolve(data);
                            }
                        });
                    }
                })
                .catch((err) => {
                    throw err;
                });
        });
    }
};

// generateVerification creates a random string for including in the OAuth2
// request, which is then validated in the response.
function generateVerification() {
    var verification = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 32; i++) {
        verification += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return verification;
}

async function getCognitoIdentity() {
    return new Promise((resolve, reject) => {
        let identity = store.state.auth.cognitoIdentity;
        if (identity.identityId) {
            return resolve(identity);
        }

        let params = {
            IdentityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID,
            AccountId: process.env.AWS_ACCOUNT_ID,
            Logins: {}
        };

        params.Logins[process.env.AWS_COGNITO_PROVIDER_ID] = store.state.auth.idToken;

        let cognitoidentity = new AWS.CognitoIdentity();
        cognitoidentity.getId(params, function (err, data) {
            if (err) {
                if (err.statusCode === 400 &&
          (err.message.indexOf('Invalid login token. Token expired') > -1 ||
            err.message.indexOf('Unauthenticated access is not supported for this identity pool.') > -1)) {
                    store.dispatch('handleSessionExpired', err);
                }
                reject(err);
            } else {
                store.commit('setCognitoIdentityId', data.IdentityId);
                resolve(store.state.auth.cognitoIdentity);
            }
        });
    });
}



// WEBPACK FOOTER //
// ./src/services/auth.js